import { all, put, select, takeLatest } from 'redux-saga/effects';
import { ContactInformationActionTypes } from './contact-information-actions';
import getAddressList from '@api/clients/contact-information/get-contact-information';
import editAddressApi from '@api/clients/contact-information/edit-contact-information';
import deleteAddressList from '@api/clients/contact-information/delete-contact-information';
import addNewAddressApi from '@api/clients/contact-information/create-contact-information';
import { AlertActionType } from '@store/alert/alert-action';
import { contactInformationStore } from '@store/client/contact-information/contact-information-store';

function* getAddressListWatcher() {
  try {
    const { cityId, currentPage, limit } = yield select(contactInformationStore);
    const addressesListResponse: { data: object } = yield getAddressList({ cityId: cityId, cache: 'no-cache', page: currentPage, limit: limit });

    yield put({
      type: ContactInformationActionTypes.SET_ADDRESS_LIST,
      data: {
        addressesList: addressesListResponse?.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: ContactInformationActionTypes.SET_DATA_LOADING,
      data: {
        dataLoading: false,
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

export function* setNewAddressWatcher() {
  try {
    const { newAddress, addressesList } = yield select(contactInformationStore);

    const addAddressResponse: { data: { route_key_affix: string, longitude: string, latitude: string } } = yield addNewAddressApi({
      address: newAddress?.address,
      longitude: newAddress?.longitude,
      latitude: newAddress?.latitude,
      plate: newAddress?.plate,
      unit: newAddress?.unit,
      cityId: newAddress.cityId,
      cache: 'no-cache',
    });

    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'آدرس جدید شما با موفقیت ذخیره شد',
      severity: 'success',
    });

    yield put({
      type: ContactInformationActionTypes.GET_ADDRESS_LIST,
      data: {
        cityId: newAddress.cityId,
      },
    });
    if (!addressesList.length) {
      yield put({
        type: ContactInformationActionTypes.SET_NEW_ADDRESS_ID,
        data: {
          selectedAddressId: addAddressResponse?.data?.route_key_affix,
          latitude: addAddressResponse?.data?.latitude,
          longitude: addAddressResponse?.data?.longitude,
        },
      });
    }
    yield put({
      type: ContactInformationActionTypes.CLEAR_NEW_ADDRESS,
    });
  } catch (error: any) {
    if (error?.code === 422) {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: error?.message || 'ثبت آدرس جدید با مشکل مواجه شد، لطفا دوباره تلاش کنید.',
        severity: 'danger',
      });
    } else {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: error?.message || 'ثبت آدرس جدید با مشکل مواجه شده است، لطفا دوباره تلاش کنید.',
        severity: 'danger',
      });
    }
  }
}

function* deleteAddressWatcher() {
  const { deletedAddressId } = yield select(contactInformationStore);

  try {
    yield deleteAddressList({
      id: deletedAddressId,
      cache: 'no-cache',
    });

    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'آدرس شما با موفقیت حذف شد',
      severity: 'success',
    });

    yield put({ type: ContactInformationActionTypes.GET_ADDRESS_LIST });
  } catch (error: any) {
    yield put({
      type: ContactInformationActionTypes.SET_DATA_LOADING,
      data: {
        dataLoading: false,
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در حذف آدرس مورد نظر مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* editAddressWatcher() {
  const { editAddressId, editAddressText, editAddressLocation, editAddressPlate, editAddressUnit } = yield select(contactInformationStore);

  try {
    yield editAddressApi({
      address: editAddressText,
      id: editAddressId,
      location: editAddressLocation,
      plate: editAddressPlate,
      unit: editAddressUnit,
      cache: 'no-cache',
    });

    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'آدرس شما با موفقیت ویرایش شد',
      severity: 'success',
    });

    yield put({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_INITIAL });

    yield put({ type: ContactInformationActionTypes.GET_ADDRESS_LIST });
  } catch (error : any) {
    yield put({ type: ContactInformationActionTypes.SET_EDIT_ADDRESS_INITIAL });
    yield put({
      type: ContactInformationActionTypes.SET_DATA_LOADING,
      data: {
        dataLoading: false,
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات شما مشکلی پیش آمده است، لطفا بعدا مراجعه نمایید',
      severity: 'danger',
    });
  }
}

function* contactInformationMiddleware() {
  yield all([
    takeLatest(ContactInformationActionTypes.GET_ADDRESS_LIST, getAddressListWatcher),
    takeLatest(ContactInformationActionTypes.SET_NEW_ADDRESS, setNewAddressWatcher),
    takeLatest(ContactInformationActionTypes.SET_DELETE_ADDRESS, deleteAddressWatcher),
    takeLatest(ContactInformationActionTypes.SET_EDIT_ADDRESS, editAddressWatcher),
    takeLatest(ContactInformationActionTypes.GET_EXTENDED_ADDRESS_LIST, getAddressListWatcher),
  ]);
}

export default contactInformationMiddleware;
